export const FREE_SHIPPING_MIN = 50;
export const TAX_CONFIG = [
    {
        state: 'CA',
        percent: 7.25
    }
];
